/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair1ica/style.css';
import FormStructure from './thecateredaffair1ica/form_structure';

export default FormStructure;